module.exports = __webpack_public_path__ + "img/green-tick.2f23804f.svg";